<template>
  <div>
    <!-- :filter="customFilter" -->
    <v-dialog v-model="show3DEditor" scrollable persistent :overlay="false" max-width="60vw"
      transition="dialog-transition">
      <v-card>
        <iframe :src="editorUrl" ref="modelCheckFrame" style="width: 100%; height: 65vh"></iframe>
      </v-card>
    </v-dialog>

    <v-row>
      <v-col cols="11">
        <v-autocomplete @change="checkNode" v-model="filterData" :items="nodelDataList" item-text="name" itemprop="key"
          label="节点搜索"></v-autocomplete>
      </v-col>
      <v-col cols="1" class="d-flex align-center justify-center">
        <v-btn color="success" small @click.stop="show3DEditor = true">
          打开视图
        </v-btn>
      </v-col>
    </v-row>

    <div style="max-height: 300px; overflow: auto; position: relative" id="treeBody">
      <Tree :setting="setting" :nodes="treeData" @onCreated="handleCreated" ref="tree" class="md-tree" />
    </div>
    <!-- :disabled="isOpenPage=='TaskActionOpenPage'"  -->
    <v-select no-data-text="暂无动作" @change="ActionPageFn" :items="actionList" item-value="id" item-text="name"
      v-model="form.templateId" label="动作"></v-select>

    <v-textarea v-if="template === 'OpenImage'" v-model="form.attachments" label="图片资源 *" rows="1" auto-grow readonly
      :rules="[(v) => !!v || '图片资源不能为空']" @mouseup.native.stop="focusAttachment('0')"></v-textarea>

    <v-textarea v-if="template === 'PlayVideo'" v-model="form.attachments" label="视频资源 *" rows="1" auto-grow readonly
      :rules="[(v) => !!v || '视频资源不能为空']" @mouseup.native.stop="focusAttachment('1')"></v-textarea>

    <v-textarea v-if="template === 'PlayAudio'" v-model="form.attachments" label="音频资源 *" rows="1" auto-grow readonly
      :rules="[(v) => !!v || '音频资源不能为空']" @mouseup.native.stop="focusAttachment('2')"></v-textarea>

    <!-- <v-textarea
      v-if="template === 'OpenPage'"
      v-model="form.pageUrl"
      label="绑定页面 *"
      rows="1"
      auto-grow
      readonly
      :rules="[(v) => !!v || '绑定页面不能为空']"
      @mouseup.native.stop="focusPageUrl()"
    ></v-textarea> -->

    <v-select v-if="template === 'OpenPage' || isConditionFlag == true" :items="currentPageList" item-value="id"
      item-text="name" v-model="form.pageId" label="选择界面" @change="ones"></v-select>
    <v-select v-if="(template === 'OpenPage' && form.pageId) || isConditionFlag == true" @change="twos"
      :items="currentPageInsList" item-value="key" item-text="name" v-model="form.pageInsKey" label="选择页面"></v-select>
    <v-treeview v-if="template === 'OpenPage' && form.pageInsKey && isConditionFlag == true" activatable
      @update:active="selectUiComponent" :items="uiPageTree"></v-treeview>
    <div v-if="form.pageInsKey" class="py-2">页面效果预览</div>
    <iframe v-if="form.pageInsKey" :src="uiPageUrl" style="width: 100%;height: 300px;"></iframe>

    <v-row v-if="template === 'Rotate'">
      <v-col col="3">
        <span>角度 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" v-model="form.rotateAnglex" :rules="[(v) => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" v-model="form.rotateAngley" :rules="[(v) => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" v-model="form.rotateAnglez" :rules="[(v) => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>
    <v-row v-if="template === 'Move'">
      <v-col col="3">
        <span>位置 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" v-model="form.positionx" :rules="[(v) => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" v-model="form.positiony" :rules="[(v) => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" v-model="form.positionz" :rules="[(v) => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="12">
        <v-select :items="[
          { id: 0, name: '直达' },
          { id: 1, name: '平滑移动' },
          { id: 2, name: '寻路' },
        ]" item-value="id" item-text="name" v-model="form.moveType" label="移动方式"></v-select>
      </v-col>
    </v-row>
    <!-- <v-select v-if="template === 'MetaAction'" :items="[
        { id: 0, name: '元件隐藏' },
        { id: 1, name: '元件显示' },
      ]" item-value="id" item-text="name" v-model="form.elementOperation" label="元件操作"></v-select> -->

    <v-text-field v-if="template === 'tag'" label="内容 *" v-model="form.tipContent"
      :rules="[(v) => !!v || '内容不能为空']"></v-text-field>

    <v-text-field v-if="template === 'tag'" label="时长 *" v-model="form.tipShowTime"
      :rules="[(v) => !!v || '时长不能为空']"></v-text-field>

    <v-row v-if="template === 'tag'">
      <v-col col="3">
        <span>位置 *</span>
      </v-col>
      <v-col col="3">
        <v-text-field label="x *" v-model="form.tipPositionX" :rules="[(v) => !!v || 'x坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="y *" v-model="form.tipPositionY" :rules="[(v) => !!v || 'y坐标 不能为空']"></v-text-field>
      </v-col>
      <v-col col="3">
        <v-text-field label="z *" v-model="form.tipPositionZ" :rules="[(v) => !!v || 'z坐标 不能为空']"></v-text-field>
      </v-col>
    </v-row>
    <v-text-field v-if="extPropData.variable_type === 'string'" v-model="form.defaultValue" label="录入值"></v-text-field>

    <v-text-field v-if="extPropData.variable_type === 'int' ||
      extPropData.variable_type === 'float'
      " v-model="form.defaultValue" label="录入值"></v-text-field>

    <v-select v-if="extPropData.variable_type === 'enum'" v-model="form.defaultValue" :items="extPropData.ranges"
      label="录入值" :rules="[(v) => !!v || '录入值不能为空']"></v-select>
    <div class="py-2" v-if="extPropData.variable_type === 'bool'">
      <label class="mr-2">录入值</label>
      <v-radio-group v-model="form.defaultValue">
        <v-radio label="true" value="true"></v-radio>
        <v-radio label="false" value="false"></v-radio>
      </v-radio-group>
    </div>
    <ResourceLibrarySelect :dialogEdit.sync="showSelectDialog" :checkMod="resourceList" :defaultType="defaultType"
      @handleCancel="handleSelectCancel" @handleSubmit="handleSelectSubmit" />
    <InterfaceTreeSelect :pageList="currentPageList" :dialogEdit.sync="showPageSelectDialog"
      @handleCancel="handlePageSelectCancel" @handleSubmit="handlePageSelectSubmit" />
  </div>
</template>

<script>
import { findTypeListBySceneId } from "@/api/device";
import { innerAction } from "../../SystemAction";
import { sceneAction } from "../../SceneAction";
import { mapState, mapGetters } from "vuex";
import Tree from "vue-giant-tree";
import ResourceLibrarySelect from "@/components/Resource/ResourceLibrarySelect";
import InterfaceTreeSelect from "@/components/Resource/InterfaceTreeSelect";
import { allInterfacePage } from "@/api/interface/interface_page";

let ztreeObj = {};
let dataMap = {};
let uiPageExtIdMap = {};

const systemInnerAction = innerAction
  .flatMap((item) => item.action_list)
  .map((item) => {
    item.type = "system_inner";
    return item;
  });

const sceneInnerAction = sceneAction
  .flatMap((item) => item.action_list)
  .map((item) => {
    item.type = "system_inner";
    return item;
  });

const defaultActionList = [].concat(systemInnerAction, sceneInnerAction);
const defaultActionMap = defaultActionList.reduce((pre, next) => {
  pre[next.id] = next;
  return pre;
}, {});

const castDataFunc = (pageData = {}, map = {}) => {
  let { cId, children, componentName, props } = pageData;
  let xField = pageData['x-field']
  children = children ?? [];
  let arr = children.map(node => castDataFunc(node, map));

  cId = componentName === 'Root' ? 0 : cId;

  let name;
  if (xField !== undefined && xField.name) {
    name = xField.name;
  } else if (props !== undefined && props.title) {
    name = props.title;
  } else {
    name = componentName;
  }

  if (xField !== undefined && xField.extendedPropertiesId) {
    map[cId] = xField.extendedPropertiesId;
  }

  return {
    id: cId,
    name,
    children: arr
  }
}


export default {
  components: {
    Tree,
    ResourceLibrarySelect,
    InterfaceTreeSelect,
  },
  props: {
    isOpenPage: {
      type: String,
      default: "",
    },
    isConditionFlag: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      // isConditionFlag:false,
      filterData: "",
      show3DEditor: false,
      selected: [],
      form: {
        defaultValue: "false",
      },
      pagination: {
        perPage: 1000,
        currentPage: 1,
      },
      list: [],
      actionMap: {},
      actionList: [],
      disabled: false,
      nodelDataList: [],
      setting: {
        check: {
          //树是否带复选框或者单选框
          enable: false,
        },
        data: {
          simpleData: {
            //是否使用简单数据模式
            enable: true,
            //树节点id，一般是后台数据库主键
            idKey: "id",
            //父级id
            pIdKey: "pid",
            rootPId: "0",
          },
        },
        //ztree回调函数
        callback: {
          //树选择事件
          onClick: this.treeNodeClick,
        },
      },
      iframeWin: {},
      extMap: {},
      // 资源弹窗
      showSelectDialog: false,
      resourceList: [],
      defaultType: "",
      // 选择页面弹窗
      showPageSelectDialog: false,
      uiPageMap: {},
      currentPageList: [],
      currentPageInsList: [],
      uiPageTree: [],
      uiPageExtId: '',
      isModFlag: false,
      realStructId: ''
    };
  },
  computed: {
    ...mapGetters(["treeData", "stepForm", "treeDataMap", "project"]),
    ...mapState({
      taskInfo: (state) => state.task.checkTaskInfo,
      definitionMap: (state) => state.editorDefinition.definitionMap,
      typeMap: (state) => state.editorType.typeMap,
    }),
    template() {
      const realStructId = this.realStructId;
      const temp_id = this.form.templateId;
      if (defaultActionMap[temp_id]) {
        return defaultActionMap[temp_id].template;
      }
      if (temp_id && this.actionMap[realStructId]) {
        const actionList =
          this.actionMap[this.form.realStructId] ?? defaultActionList;

        const act = actionList.find((item) => item.id === temp_id);
        return act ? act.template : "";
      }
      return "";
    },
    actData() {
      const temp_id = this.form.templateId;
      const actionList = this.actionMap[this.form.realStructId];
      if (!actionList) return {};
      const act = actionList.find((item) => item.id === temp_id);
      return act ?? {};
    },
    editorUrl() {
      return `${process.env.VUE_APP_3D_CHOOSE_EDITOR_URL}?id=1&edt_id=${this.taskInfo.taskEditor}&projectId=${this.project._id}`;
    },
    uiPageUrl() {
      const uiUrl = `${process.env.VUE_APP_UI_PAGE_URL}/preview-render?p=${this.form.pageId}&key=${this.form.pageInsKey}`;
      return uiUrl;
    },
    /** 选择动作的拓展属性 */
    extPropData() {
      const realStructId = this.realStructId;

      if (!realStructId || !this.extMap) return {};
      const extList = this.extMap[realStructId];
      const extId = this.actData.extendedPropertiesId || this.uiPageExtId;
      if (!extList || !extId) return {};
      const extInfo = extList.find((item) => item.id === extId);
      return extInfo ?? {};

    },
  },
  watch: {
    "isOpenPage": {
      handler(val) {
        if (val == "TaskActionOpenPage") {  //打开页面选中
          //  this.form.templateId = 'inner_012'
          this.$set(this.form, 'templateId', 'inner_012')
        }
      }
    },
    "form": {
      handler(val) {
        console.log('表单修改', val);
        const arr = this.actionMap[this.form.realStructId] ?? defaultActionList;
        if (!arr || !arr.find) return;
        const act = arr.find((item) => item.id === val);
        if (act) {
          this.form.typeId = null;
          this.form.actionData = null;
          this.form.templateName = null;
        }
        let obj = {
          targetPath: this.form.targetPath || "",
          actionName: this.form.actionData ? this.form.actionData.name : this.form.templateName,
          monitorParamValue: this.form.actionData,
        }
        if (this.form.templateName == '移动') {
          obj.camMoveType = this.form.moveType;
          obj.camPos = [this.form.positionx, this.form.positiony, this.form.positionz]
          this.$emit("setTargePath", obj)
        } else if (this.form.templateName == '旋转') {
          obj.camQuaternion = [this.form.rotateAnglex, this.form.rotateAngley, this.form.rotateAnglez]
          this.$emit("setTargePath", obj)

        } else if (this.form.templateName == '标签') {
          obj.tipCon = {
            tipContent: this.form.tipContent,
            tipPositionX: this.form.tipPositionX,
            tipPositionY: this.form.tipPositionY,
            tipPositionZ: this.form.tipPositionZ,
            tipShowTime: this.form.tipShowTime
          }
          this.$emit("setTargePath", obj)
        } else if (this.form.templateName == '打开页面') {
          obj.pageId = this.form.pageId
          obj.pageInsKey = this.form.pageInsKey
          obj.baseUIPageUrl = 'http://demo-platform.icubespace.com/preview-render';
          this.$emit("setTargePath", obj)
        } {
          if (val.hasOwnProperty('defaultValue')) this.$emit("setBoolea", val.defaultValue)
          // this.$emit("setBoolea",val)
          this.$emit("setTargePath", obj)
        }
      },
      deep: true,
    },
    "form.templateId"(val) {
      if (val) {
        const arr = this.actionMap[this.form.realStructId] ?? defaultActionList;
        if (!arr || !arr.find) return;
        const act = arr.find((item) => item.id === val);

        if (act) {
          this.form.typeId = act._id;
          this.form.actionData = act;
          this.form.templateName = act.name;
        } else {
        }

        this.currentPageList = this.uiPageMap[this.form.realStructId] ?? []

        this.$emit("setTargePath", {
          targetPath: this.form.targetPath,
          actionName: this.form.actionData.name,
          monitorParamValue: this.form.actionData
        })



        //元件操作 id inner_001
        //移动 id "inner_003"
        //旋转 "inner_004"
        //缩放   "inner_005"
        //高亮   "inner_006"
        //取消高亮 "inner_007"
        //停止播放动画 "inner_008"
        //打开页面 "inner_012"
        //关闭页面 "inner_013"
        //标签   "scene_001"

      }
    },
    "form.pageId"(val) {
      if (val) {
        allInterfacePage({ parentId: val }).then(res => {
          this.currentPageInsList = res.data.rows;
        })
      }
    },
    "form.pageInsKey"(val) {
      if (val) {
        const insPage = this.currentPageInsList.find(item => item.key === val)
        let data = JSON.parse(insPage.pageJSON);
        this.uiPageTree = [castDataFunc(data, uiPageExtIdMap)];
      }
    },
    'form.templateName'(val) {
      //  console.log(val)
      if (val) {
        this.isModFlag = true
        return
      }
      this.isModFlag = false
    },
    "form.defaultValue"(val) {
      this.$emit("setBoolea", val)
    },
    // 'extPropData'(val){
    //   if(val){
    //       this.form.defaultValue = val.default_value 
    //       if(val&&val.variable_type){
    //         this.$emit("setTargePath",{
    //           "isOpenDo":true,
    //           "monitorParamValue" : val.default_value
    //         })
    //       }
    //   }
    // },




    show3DEditor(val) {
      if (val) {
        const _this = this;
        this.$nextTick(() => {
          _this.iframeWin = _this.$refs.modelCheckFrame.contentWindow;

          window.addEventListener(
            "message",
            (event) => {
              if (!event.data) return;
              // 选择模型
              if (event.data.cmd === "cancel") {
                _this.show3DEditor = false;
              }
              if (event.data.cmd === "modelConfirm") {
                _this.show3DEditor = false;
                _this.checkNode(event.data.data);
              }
            },
            false
          );
        });
      } else {
        window.removeEventListener("message");
      }
    },
    extPropData(val) {
      // console.log(val)
      if (this.form.defaultValue === undefined) {
        this.form.defaultValue = val.default_value;
      }
    },
  },
  mounted() {
    this.getList();
  },
  methods: {

    setPage(data) {
      if (data) {
        this.form.pageId = data.pageId
        allInterfacePage({ parentId: data.pageId }).then(res => {
          this.currentPageInsList = res.data.rows;
          this.form.pageInsKey = data.pageInsKey
        })
        //  this.form.pageId = data.pageInsKey
      }
    },

    setDefeatValue(data) {
      this.form.defaultValue = data;

    },
    ones(data) {
      let obj = {
        pageId: data,
        pageInsKey: this.form.pageInsKey,
      }
      this.$emit("setPageInsk", obj)
    },
    twos(data) {
      let obj = {
        pageId: this.form.pageId,
        pageInsKey: data,
      }
      this.$emit("setPageInsk", obj)
    },
    ActionPageFn(data) {

      // if(){}

    },
    setAdtiveData(data) {

      this.setValues(data)

      if (data && data.monitorParamValue) {
        this.$set(this.form, 'templateId', data.monitorParamValue.id)
        this.$set(this.form, 'typeId', data.monitorParamValue.id)
        this.$set(this.form, 'templateName', data.monitorParamValue.name)
        this.$set(this.form, 'actionData', data.monitorParamValue)
      } else {
        this.$set(this.form, 'templateId', '')
        this.$set(this.form, 'templateName', '')
        this.$set(this.form, 'actionData', {})
      }
    },
    setValues(data) {
      if (data) {
        if (data.actionName && data.actionName == "移动") {
          this.$set(this.form, 'moveType', data.camMoveType && data.camMoveType)
          this.$set(this.form, 'positionx', data.camPos && data.camPos[0])
          this.$set(this.form, 'positiony', data.camPos && data.camPos[1])
          this.$set(this.form, 'positionz', data.camPos && data.camPos[2])
        } else if (data.actionName && data.actionName == "旋转") {
          this.$set(this.form, 'rotateAnglex', data.camQuaternion && data.camQuaternion[0])
          this.$set(this.form, 'rotateAngley', data.camQuaternion && data.camQuaternion[1])
          this.$set(this.form, 'rotateAnglez', data.camQuaternion && data.camQuaternion[0])
        } else if (data.actionName && data.actionName == "标签") {

          this.$set(this.form, 'tipContent', data.tipCon && data.tipCon.tipContent)
          this.$set(this.form, 'tipPositionX', data.tipCon && data.tipCon.tipPositionX)
          this.$set(this.form, 'tipPositionY', data.tipCon && data.tipCon.tipPositionY)
          this.$set(this.form, 'tipPositionZ', data.tipCon && data.tipCon.tipPositionZ)
          this.$set(this.form, 'tipShowTime', data.tipCon && data.tipCon.tipShowTime)

        }
      }

    },
    treeNodeClick(obj, id, treeNode) {
      console.log('点击触发 :>> ');
      this.form.structId = treeNode.id;
      this.form.metaName = treeNode.name;
      this.form.targetPath = this.treeDataMap[treeNode.id].targetPath;
      const realStructId = treeNode.id;
      this.realStructId = realStructId;
      this.form.realStructId = realStructId;
      this.actionList = this.actionMap[realStructId] ?? defaultActionList;




      //元件操作 id inner_001
      //移动 id "inner_003"
      //旋转 "inner_004"
      //缩放   "inner_005"
      //高亮   "inner_006"
      //取消高亮 "inner_007"
      //停止播放动画 "inner_008"
      //打开页面 "inner_012"
      //关闭页面 "inner_013"
      //标签   "scene_001"


      this.$emit("setTargePath", {
        targetPath: this.form.targetPath,
        // activeName:
        // metaName:this.form.metaName
      })
    },
    init(form) {
      this.form = Object.assign({}, form);
      if (ztreeObj) {
        ztreeObj.refresh();
      }
      this.handleNodeAutoFocus();
    },
    getList() {
      // const projectId = this.taskInfo.project;
      const courseId = this.taskInfo.course?this.taskInfo.course:'';
      findTypeListBySceneId({
        // sceneId: this.taskInfo.taskEditor,
        // type: "editor",
        courseId,
      }).then((res) => {
        this.list = res.data;

        let extMap = {};
        let uiPageMap = {};

        this.actionMap = res.data.reduce((pre, next) => {
          // 获取类型的动作列表
          pre[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.actions
            : [];

          // 记录类型id
          pre[next.structId] = pre[next.structId].map((item) => {
            item._id = next.deviceTypeInfo._id;
            return item;
          });

          // 拼接默认的系统动作
          pre[next.structId] = pre[next.structId].concat(defaultActionList);

          // 根据结构id记录属性列表
          extMap[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.extended_properties
            : [];

          uiPageMap[next.structId] = next.deviceTypeInfo
            ? next.deviceTypeInfo.interface
            : [];
          return pre;
        }, {});

        this.extMap = extMap;
        this.uiPageMap = uiPageMap;

        if (this.form && this.form.structId) {
          this.actionList =
            this.actionMap[this.form.realStructId] ?? defaultActionList;
        }

        res.data.reduce((pre, next) => {
          pre[next.structId] = next;
          return pre;
        }, dataMap);
      });
    },

    selectUiComponent(e) {
      const id = e.join();
      this.form.uiPageComponentId = id;
      this.uiPageExtId = uiPageExtIdMap[id];
    },

    handleNodeAutoFocus() {
      if (!ztreeObj) return;
      let uuuid = this.stepForm.realStructId;
      let nodes = ztreeObj.getNodes();
      console.log("nodes :>> ", nodes);
      let setModel = (l, arr = []) => {
        return l.flatMap((v) => {
          if (v.id === uuuid) {
            let tId = v.tId;

            ztreeObj.refresh();

            let nodeList = ztreeObj.getNodesByParam("id", uuuid); //模糊搜索
            if (nodeList[0]) {
              let parentList = ztreeObj.getNodesByParam("id", nodeList[0].pid);
              if (parentList[0]) {
                ztreeObj.expandNode(parentList[0], true, false, false);
              }
            }
            this.$nextTick(() => {
              let dom = document.getElementById(tId + "_a");
              if (dom) {
                dom.click();
              }
            });
          }
          const useArr = [].concat(arr);
          useArr.push(v.name);

          const obj = {
            key: v.id,
            name: useArr.join("/"),
            tId: v.tId,
          };

          if (v.children && v.children.length !== 0) {
            return [obj].concat(setModel(v.children, useArr));
          }
          return [obj];
        });
      };

      this.nodelDataList = setModel(nodes);
    },
    handleCreated(obj) {
      ztreeObj = obj;
      this.handleNodeAutoFocus();
    },
    checkChange(data) {
    },
    checkNode(e) {
      const data = this.nodelDataList.find((item) => item.name === e);
      const uuuid = data.key;
      ztreeObj.expandAll(false);
      let nodeList = ztreeObj.getNodesByParam("id", uuuid); //模糊搜索
      if (nodeList[0]) {
        let parentList = ztreeObj.getNodesByParam("id", nodeList[0].pid);
        if (parentList[0]) {
          ztreeObj.expandNode(parentList[0], true, false, false);
        }
      }
      ztreeObj.refresh();

      this.$nextTick(() => {
        let dom = document.getElementById(data.tId + "_a");
        let bodyDom = document.getElementById("treeBody");
        bodyDom.scrollTop = dom.offsetTop;
        if (dom) {
          dom.click();
        }
      });
      // pageInsKey
      this.getList()
      setTimeout(() => {
        this.currentPageList = this.uiPageMap[this.form.realStructId] ?? []
      }, 400)

    },

    // 资源弹窗
    focusAttachment(type) {
      this.defaultType = type;
      this.showSelectDialog = true;
      // 解决第一次弹窗闪屏问题
      setTimeout(() => {
        this.showSelectDialog = true;
      }, 100);
      this.resourceList = this.form.attachment_url;
    },
    handleSelectSubmit(checkList) {
      this.resourceList = checkList;
      this.form.attachment_url = checkList.map((item) => {
        return {
          _id: item._id,
          name: item.name,
        };
      });
      this.form.attachments = checkList.map((item) => item.name).join(",");
      this.showSelectDialog = false;
    },

    handleSelectCancel() {
      this.showSelectDialog = false;
    },

    // 页面选择弹窗
    focusPageUrl() {
      this.showPageSelectDialog = true;
    },
    handlePageSelectSubmit(selected) {
        this.form.pageUrl =
          `${process.env.VUE_APP_UI_PAGE_URL}/preview-render?p=` +
          selected[0].pId +
          "&key=" +
          selected[0].key;

      this.showPageSelectDialog = false;
    },


    handlePageSelectCancel() {
      this.showPageSelectDialog = false;
    },
  },
};
</script>

<style></style>
